// extracted by mini-css-extract-plugin
module.exports = {"TextInput":"text-area-input_TextInput__MI6ut"};